module.exports = __webpack_public_path__ + "static/media/fruits-cut.cb4ee9c5.jpeg";